import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { X, Plus } from 'lucide-react';

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const MAX_CC = 10;

export const DailyCcEditor = ({ ccList, onChange, disabled }) => {
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  const addEmail = () => {
    const e = input.trim().toLowerCase();
    if (!e) return;
    if (!EMAIL_RE.test(e)) { setError('Enter a valid email address'); return; }
    if (ccList.includes(e)) { setError('Already in the list'); return; }
    if (ccList.length >= MAX_CC) { setError(`Maximum ${MAX_CC} CC addresses`); return; }
    onChange([...ccList, e]);
    setInput('');
    setError('');
  };

  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <Input
          type="email"
          value={input}
          onChange={(e) => { setInput(e.target.value); setError(''); }}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addEmail(); } }}
          placeholder="name@company.com"
          disabled={disabled}
          data-testid="cc-email-input"
        />
        <Button type="button" variant="outline" onClick={addEmail} disabled={disabled} data-testid="cc-add-btn">
          <Plus size={14} className="mr-1" /> Add
        </Button>
      </div>
      {error && <p className="text-xs text-red-600" data-testid="cc-input-error">{error}</p>}
      {ccList.length === 0 ? (
        <p className="text-sm text-gray-400" data-testid="cc-empty">No CC recipients yet.</p>
      ) : (
        <div className="flex flex-wrap gap-2" data-testid="cc-list">
          {ccList.map((e) => (
            <span
              key={e}
              className="inline-flex items-center gap-1.5 bg-purple-50 text-purple-800 border border-purple-200 rounded-full px-3 py-1 text-xs font-medium"
              data-testid={`cc-chip-${e}`}
            >
              {e}
              {!disabled && (
                <button
                  type="button"
                  onClick={() => onChange(ccList.filter((x) => x !== e))}
                  className="text-purple-500 hover:text-red-600"
                  data-testid={`cc-remove-${e}`}
                >
                  <X size={12} />
                </button>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default DailyCcEditor;
